import { defineMessages } from "react-intl";

export default defineMessages({
  bankTransfer: {
    id: "paymentMethods.bankTransfer",
    defaultMessage: "Transfer",
  },
  noBankTransfer: {
    id: "paymentMethods.noBankTransfer",
    defaultMessage: "No bank transfer",
  },
  bankTransferTransactionsAreNotSupportedForThisService: {
    id: "paymentMethods.bankTransferTransactionsAreNotSupportedForThisService",
    defaultMessage:
      "Bank transfer transactions are not supported for this service",
  },
});
